Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
exports.ExpressLayerType = void 0; (function (ExpressLayerType) {
  const ROUTER = 'router'; ExpressLayerType["ROUTER"] = ROUTER;
  const MIDDLEWARE = 'middleware'; ExpressLayerType["MIDDLEWARE"] = MIDDLEWARE;
  const REQUEST_HANDLER = 'request_handler'; ExpressLayerType["REQUEST_HANDLER"] = REQUEST_HANDLER;
})(exports.ExpressLayerType || (exports.ExpressLayerType = {}));
//# sourceMappingURL=ExpressLayerType.js.map
